// Province codes for Canada
export const ECanadianProvince = {
  AB: "AB", // Alberta
  BC: "BC", // British Columbia
  MB: "MB", // Manitoba
  NB: "NB", // New Brunswick
  NL: "NL", // Newfoundland and Labrador
  NS: "NS", // Nova Scotia
  NT: "NT", // Northwest Territories
  NU: "NU", // Nunavut
  ON: "ON", // Ontario
  PE: "PE", // Prince Edward Island
  QC: "QC", // Quebec
  SK: "SK", // Saskatchewan
  YT: "YT", // Yukon
} as const;

export type ECanadianProvince =
  (typeof ECanadianProvince)[keyof typeof ECanadianProvince];

export const CanadianProvinceOptions: {
  label: string;
  value: ECanadianProvince;
}[] = [
  {
    label: "Alberta",
    value: ECanadianProvince.AB,
  },
  {
    label: "British Columbia",
    value: ECanadianProvince.BC,
  },
  {
    label: "Manitoba",
    value: ECanadianProvince.MB,
  },
  {
    label: "New Brunswick",
    value: ECanadianProvince.NB,
  },
  {
    label: "Newfoundland and Labrador",
    value: ECanadianProvince.NL,
  },
  {
    label: "Nova Scotia",
    value: ECanadianProvince.NS,
  },
  {
    label: "Northwest Territories",
    value: ECanadianProvince.NT,
  },
  {
    label: "Nunavut",
    value: ECanadianProvince.NU,
  },
  {
    label: "Ontario",
    value: ECanadianProvince.ON,
  },
  {
    label: "Prince Edward Island",
    value: ECanadianProvince.PE,
  },
  {
    label: "Quebec",
    value: ECanadianProvince.QC,
  },
  {
    label: "Saskatchewan",
    value: ECanadianProvince.SK,
  },
  {
    label: "Yukon",
    value: ECanadianProvince.YT,
  },
] as const;
